type ProbeEventKind = "TOUCHEND_CAPTURE" | "TOUCHEND_BUBBLE" | "CLICK_CAPTURE" | "CLICK_BUBBLE";

function isHybridRuntime() {
  return (navigator.userAgent || "").includes("MOREPOSHybrid/");
}

function targetSummary(target: EventTarget | null) {
  if (!(target instanceof Element)) return "target=unknown";

  const element = target.closest("button, input, [role='button']") ?? target;
  const tag = element.tagName.toLowerCase();
  const className = typeof element.className === "string" ? element.className.trim().replace(/\s+/g, ".") : "";
  const disabled = element instanceof HTMLButtonElement || element instanceof HTMLInputElement
    ? element.disabled
    : false;

  return `${tag}${className ? `.${className}` : ""} disabled=${disabled ? "yes" : "no"}`;
}

function ensureBadge() {
  let badge = document.getElementById("more-pos-hybrid-interaction-probe");
  if (badge) return badge;

  badge = document.createElement("div");
  badge.id = "more-pos-hybrid-interaction-probe";
  badge.setAttribute(
    "style",
    "position:fixed;z-index:2147483645;left:10px;bottom:10px;max-width:78vw;padding:8px 10px;border-radius:9px;background:#111;color:#ffd400;font:700 12px/1.3 monospace;box-shadow:0 2px 8px rgba(0,0,0,.35);pointer-events:none;display:none",
  );
  document.body.appendChild(badge);
  return badge;
}

function show(kind: ProbeEventKind, target: EventTarget | null) {
  const badge = ensureBadge();
  badge.textContent = `${kind} · ${targetSummary(target)}`;
  badge.style.display = "block";
}

export function registerHybridInteractionProbe() {
  if (!isHybridRuntime()) return;

  document.addEventListener("touchend", (event) => {
    show("TOUCHEND_CAPTURE", event.target);
  }, true);

  document.addEventListener("touchend", (event) => {
    show("TOUCHEND_BUBBLE", event.target);
  });

  document.addEventListener("click", (event) => {
    show("CLICK_CAPTURE", event.target);
  }, true);

  document.addEventListener("click", (event) => {
    show("CLICK_BUBBLE", event.target);
  });
}
